import type { AppCategory } from "@/api/queries";

/** Categories in display order. */
export const categories: readonly AppCategory[] = ["productive", "neutral", "unproductive"];
